import Chart from 'chart.js/auto';

const co2=[9.036, 9.07, 8.557, 8.572, 9.468, 9.059, 9.009]
const ch4GWP20=[1.8220978080525, 1.8457205108925, 1.8583192857075, 1.8772174479300001, 1.9165886191650001, 1.78587633048, 1.9731508086674998]
const ch4GWP100=[0.6581638143026001, 0.6666966209042, 0.6712474510798, 0.6780736963432001, 0.6922950406196, 0.6450801775552001, 0.7127259890702]

const ch4CTcolor = '#FF761A';
const ch4EEAcolor = '#6D5337';
const co2CTcolor = '#deff21';
const co2EEAcolor = '#535f0d';


const thisChart = document.getElementById('bar-chart-grouped');

Chart.defaults.font.size = 16;
Chart.defaults.color = '#000000'

let chartObj = new Chart(thisChart, {
	type: 'bar',
	data: {
		labels: [ '2015', '2016', '2017', '2018', '2019', '2020', '2021' ],
		datasets: [
			{
				label: 'CO₂ (Europees Milieuagentschap)',
				backgroundColor: co2EEAcolor,
				data: co2
			},
			{
				label: 'Methaan (Climate TRACE)',
				backgroundColor: ch4CTcolor,
				data: ch4GWP20
			}
		]
	},

	options: {
		title: {
			display: true,
			text: ''
		},
		scales: {
			x: {
				stacked: true
			},
			y: {
				stacked: true,
				title: {
				  display: true,
				  text: 'Megaton CO₂-eq, GWP-20'
				}
			}
		},
		maintainAspectRatio: false
	}
});


var radio2 = document.getElementById('op2');
radio2.addEventListener('change', function() {
	if (this.checked) {
		chartObj.data.datasets[1].data = ch4GWP20;
		//chartObj.data.datasets[1].label = 'Methaan, CO₂-eq op basis van GWP-20 (Climate Trace)';
		chartObj.options.scales.y.title.text = "Megaton CO₂-eq, GWP-20"
		chartObj.update();
	}
});

var radio3 = document.getElementById('op3');
radio3.addEventListener('change', function() {
	if (this.checked) {
		chartObj.data.datasets[1].data = ch4GWP100;
		//chartObj.data.datasets[1].label = 'Methaan, CO₂e op basis van GWP-100 (Climate Trace)';
		chartObj.options.scales.y.title.text = "Megaton CO₂-eq, GWP-100"
		chartObj.update();
	}
});
